import { Injectable } from '@angular/core';
import { NbToastrConfig, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { Alert } from '../models/alert.model';

@Injectable({ providedIn: 'root' })
export class AlertService {
    constructor(
        private toastrService: NbToastrService,
        private translate: TranslateService
    ) { }

    success(message: string | number, time: number = 5000, config?: Partial<NbToastrConfig>) {
        let alert: Alert = {
            icon: "checkmark-outline",
            type: "primary",
            title: "Success"
        };
        this.send(alert, message, time, config);
    }

    danger(message: string | number, time: number = 5000, config?: Partial<NbToastrConfig>) {
        let alert: Alert = {
            icon: "alert-triangle-outline",
            type: "danger",
            title: "Error"
        };
        this.send(alert, message, time, config);
    }

    warning(message: string | number, time: number = 5000, config?: Partial<NbToastrConfig>) {
        let alert: Alert = {
            icon: "alert-circle-outline",
            type: "warning",
            title: "Warning"
        };
        this.send(alert, message, time, config);
    }

    info(message: string | number, time: number = 5000, config?: Partial<NbToastrConfig>) {
        let alert: Alert = {
            icon: "question-mark-circle-outline",
            type: "info",
            title: "Info"
        };

        this.send(alert, message, time, config);
    }

    private send(alert: Alert, message: string | number, time: number = 5000, config?: Partial<NbToastrConfig>) {
        try {
            const bodyMessage = this.isNumber(message) ? `errors.${message}` : message.toString();
            if (!config) {
                this.toastrService.show(this.translate.instant(bodyMessage), `${alert.title}!`,
                    {
                        icon: { icon: alert.icon, pack: "eva" },
                        duration: time,
                        status: alert.type,
                        preventDuplicates: true,
                        duplicatesBehaviour: "all"
                    });
            } else {
                this.toastrService.show(this.translate.instant(bodyMessage), `${alert.type}!`, config);
            }
        } catch (e) {
            this.toastrService.show(this.translate.instant(`errors.4100`), `${alert.title}!`,
                {
                    icon: { icon: alert.icon, pack: "eva" },
                    duration: time,
                    status: alert.type,
                    preventDuplicates: true,
                    duplicatesBehaviour: "all"
                });
        }
    }

    private isNumber(value: string | number): boolean {
        return ((value != null) && (value !== "") && !isNaN(Number(value.toString())));
    }
}
